/**
 * BeezFy Popup Manager
 * Manages the premium ATC popup
 */

(function() {
  'use strict';

  class BeezfyPopupManager {
    constructor() {
      this.popup = null;
      this.timeout = null;
      this.init();
    }

    init() {
      this.createPopup();
      this.setupEventListeners();

      // Make globally accessible
      window.BeezfyPopup = this;
    }

    createPopup() {
      // Check if popup already exists
      if (document.getElementById('beezfy-atc-popup')) {
        this.popup = document.getElementById('beezfy-atc-popup');
        return;
      }

      // Create popup HTML
      this.popup = document.createElement('div');
      this.popup.id = 'beezfy-atc-popup';
      this.popup.className = 'beezfy-atc-popup';
      this.popup.innerHTML = `
        <div class="beezfy-atc-popup__overlay"></div>
        <div class="beezfy-atc-popup__container">
          <button class="beezfy-atc-popup__close" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2"/>
            </svg>
          </button>

          <div class="beezfy-atc-popup__content">
            <div class="beezfy-atc-popup__success-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="22" stroke="#059669" stroke-width="4"/>
                <path d="M14 24L20 30L34 16" stroke="#059669" stroke-width="4" stroke-linecap="round"/>
              </svg>
            </div>

            <h3 class="beezfy-atc-popup__title">Added to Cart!</h3>
            <p class="beezfy-atc-popup__message">Product successfully added to your shopping cart</p>

            <div class="beezfy-atc-popup__product">
              <img class="beezfy-atc-popup__product-image" src="" alt="">
              <div class="beezfy-atc-popup__product-info">
                <div class="beezfy-atc-popup__product-title"></div>
                <div class="beezfy-atc-popup__product-variant"></div>
                <div class="beezfy-atc-popup__product-price"></div>
              </div>
            </div>

            <div class="beezfy-atc-popup__actions">
              <button class="beezfy-atc-popup__continue">Continue Shopping</button>
              <a href="/cart" class="beezfy-atc-popup__view-cart">View Cart</a>
              <a href="/checkout" class="beezfy-atc-popup__checkout">Checkout</a>
            </div>

            <div class="beezfy-atc-popup__footer">
              <div class="beezfy-atc-popup__trust">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M8 0L10 6H16L11 10L13 16L8 12L3 16L5 10L0 6H6L8 0Z"/>
                </svg>
                <span>Free shipping on orders over $100</span>
              </div>
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(this.popup);
    }

    setupEventListeners() {
      if (!this.popup) return;

      // Close button
      const closeBtn = this.popup.querySelector('.beezfy-atc-popup__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.close());
      }

      // Continue shopping button
      const continueBtn = this.popup.querySelector('.beezfy-atc-popup__continue');
      if (continueBtn) {
        continueBtn.addEventListener('click', () => this.close());
      }

      // Overlay click
      const overlay = this.popup.querySelector('.beezfy-atc-popup__overlay');
      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }

      // ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.popup.classList.contains('active')) {
          this.close();
        }
      });
    }

    show(data = {}) {
      // Update popup content if data provided
      if (data.product) {
        this.updateContent(data.product, data.variant, data.quantity);
      }

      // Show popup
      this.popup.classList.add('active');
      document.body.classList.add('popup-open');

      // Auto close after 5 seconds
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.close();
      }, 5000);
    }

    close() {
      this.popup.classList.remove('active');
      document.body.classList.remove('popup-open');
      clearTimeout(this.timeout);
    }

    updateContent(product, variant, quantity = 1) {
      // Update product image
      const imageEl = this.popup.querySelector('.beezfy-atc-popup__product-image');
      if (imageEl && variant?.featured_image) {
        imageEl.src = variant.featured_image.src || variant.featured_image;
        imageEl.alt = product.title;
      } else if (imageEl && product.featured_image) {
        imageEl.src = product.featured_image;
        imageEl.alt = product.title;
      }

      // Update product title
      const titleEl = this.popup.querySelector('.beezfy-atc-popup__product-title');
      if (titleEl) {
        titleEl.textContent = product.title;
      }

      // Update variant info
      const variantEl = this.popup.querySelector('.beezfy-atc-popup__product-variant');
      if (variantEl && variant) {
        variantEl.textContent = variant.title !== 'Default Title' ? variant.title : '';
      }

      // Update price
      const priceEl = this.popup.querySelector('.beezfy-atc-popup__product-price');
      if (priceEl && variant) {
        const price = (variant.price / 100).toFixed(2);
        priceEl.textContent = `$${price} × ${quantity}`;
      }

      // Update message
      const messageEl = this.popup.querySelector('.beezfy-atc-popup__message');
      if (messageEl) {
        messageEl.textContent = `${quantity} item${quantity > 1 ? 's' : ''} added to your cart`;
      }
    }
  }

  // Initialize when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new BeezfyPopupManager();
    });
  } else {
    new BeezfyPopupManager();
  }

})();